<template>
  <div class="archives">
    <material-item
      v-for="(archive, i) in archives"
      :key="i"
      :archive="archive"
    />

    <div
      v-if="!archives || archives.length === 0"
      class="small text-center text-secondary p-3"
    >
      <em>Nenhum arquivo</em>
    </div>
  </div>
</template>

<script>
import MaterialItem from "./materials/MaterialItem";

export default {
  components: {
    MaterialItem
  },
  props: {
    archives: {
      type: Array,
      default: () => []
    }
  }
};
</script>
